import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import icons from "../../../assets/images/constantIcons";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";
import toast from "react-hot-toast";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";

const EditPayableForm = ({ isOpen, onClose, booking_id, fetchPlayers, tableCharge, startTime, today_amount }) => {
    const [PlayersData, setPlayersData] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [selectedTable, setSelectedTable] = useState(null);
    const [showPlayerPopup, setShowPlayerPopup] = useState(false);

    useEffect(() => {
        const fetchBookingData = async () => {
            try {
                const response = await apiService.get(`/bookings/${booking_id}`);
                setPlayersData(response.data);
                const defaultPayableIds = response.data?.payable_players?.map(player => player.id) || [];
                formik.setFieldValue("payable_ids", defaultPayableIds);
            } catch (errors) {
                handleError(errors);
            }
        };
        if (booking_id) {
            fetchBookingData();
        }
    }, [booking_id]);

    const playerOptions = PlayersData?.players?.map((customer) => ({
        label: customer.name,
        value: customer.id,
    }));

    const formik = useFormik({
        initialValues: {
            payable_ids: [],
            ratios: [],
            today_amount: today_amount,
        },
        validationSchema: Yup.object({
            payable_ids: Yup.array()
                .of(Yup.number().required("Payable ID must be a number"))
                .min(1, "Payable is required"),
        }),
        onSubmit: async (values) => {
            setIsSubmitting(true);
            try {
                const payload = {
                    booking: {
                        payable_ids: values.payable_ids,
                        ratios: values.ratios,
                    },
                };

                const response = await apiService.patch(`/bookings/${booking_id}/change_payable`, payload);
                if (response.status === 200) {
                    onClose();
                    toast.success(response.message, { duration: 2000 });
                    fetchPlayers("previous");
                }
            } catch (errors) {
                handleError(errors);
            } finally {
                setIsSubmitting(false);
            }
        },
    });

    return (
        isOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                <div className="bg-white rounded-lg p-4 s:p-6 w-[310px] s:w-[350px] md:w-[460px] relative">
                    <div
                        className="absolute top-7 right-3 bg-green50 rounded-full p-2 cursor-pointer w-[32px] h-[32px]"
                        onClick={() => {
                            formik.resetForm();
                            onClose();
                        }}
                    >
                        <icons.IoClose className="text-green700" />
                    </div>
                    <h2 className="text-xl font-semibold mb-5 text-G500 text-start">
                        Edit Payable
                    </h2>

                    <form
                        onSubmit={formik.handleSubmit}
                        className="space-y-4 text-start h-auto vertical"
                    >

                        <div className="text-G300">
                            <label className="block text-sm font-normal mb-2">Payable</label>
                            <div className="border border-separate rounded-md p-2 space-y-2 max-h-44 overflow-y-auto vertical">
                                <div className="flex justify-between items-center px-2 py-1 border-b border-gray-300 text-xs font-semibold text-gray-600 bg-gray-100">
                                    <div className="w-52">Player Name</div>
                                    <div className="w-12 text-right">Ratio</div>
                                    <div className="w-20 text-right">Amount</div>
                                </div>
                                {PlayersData?.players?.map((player, index) => {
                                    const parseRatio = (ratioStr) => {
                                        const num = parseInt(ratioStr, 10);
                                        return isNaN(num) ? 0 : num;
                                    };

                                    const isChecked = formik.values.payable_ids.includes(player.id);
                                    const currentRatio = formik.values.ratios[index];
                                    const currentParsedRatio = parseRatio(currentRatio);

                                    const totalRatio = formik.values.ratios.reduce((sum, ratio) => sum + parseRatio(ratio), 0);

                                    const ratioAmt =
                                        totalRatio > 0 ? (today_amount * currentParsedRatio) / totalRatio : 0;

                                    const shareAmount = ratioAmt > 0 ? Math.ceil(ratioAmt / 5) * 5 : 0;

                                    // const handleCheckboxChange = (e) => {
                                    //     let newPayableIds;
                                    //     const updatedRatios = [...formik.values.ratios];

                                    //     if (e.target.checked) {
                                    //         newPayableIds = [...formik.values.payable_ids, player.id];
                                    //     } else {
                                    //         newPayableIds = formik.values.payable_ids.filter(id => id !== player.id);
                                    //         updatedRatios[index] = ""; 
                                    //     }

                                    //     formik.setFieldValue("payable_ids", newPayableIds);
                                    //     formik.setFieldValue("ratios", updatedRatios);
                                    // };

                                    const handleCheckboxChange = (e) => {
                                        const updatedPayableIds = e.target.checked
                                            ? [...formik.values.payable_ids, player.id]
                                            : formik.values.payable_ids.filter((id) => id !== player.id);

                                        const updatedRatios = [...formik.values.ratios];

                                        if (!e.target.checked) {
                                            updatedRatios[index] = null; 
                                        }

                                        formik.setFieldValue("payable_ids", updatedPayableIds);
                                        formik.setFieldValue("ratios", updatedRatios);
                                    };
                                    const handleRatioChange = (e) => {
                                        const value = e.target.value;
                                        const validFormat = /^[0-9]{0,2}$/;
                                        if (validFormat.test(value)) {
                                            const updatedRatios = [...formik.values.ratios];
                                            updatedRatios[index] = value;
                                            formik.setFieldValue("ratios", updatedRatios);
                                        }
                                    };

                                    return (
                                        <div key={player.id} className="flex flex-col">
                                            <div className="flex justify-between items-center border rounded-md px-2 py-[2px] bg-gray-50">
                                                <label className="flex items-center text-sm font-medium">
                                                    <input
                                                        type="checkbox"
                                                        checked={isChecked}
                                                        onChange={handleCheckboxChange}
                                                        className="mr-2"
                                                    />
                                                    {player.name}
                                                </label>
                                                <div className="flex items-center gap-3">
                                                    <input
                                                        type="text"
                                                        placeholder="2"
                                                        className="w-12 text-sm px-2 py-[2px] border border-G80 rounded-lg outline-none"
                                                        value={currentRatio}
                                                        onChange={handleRatioChange}
                                                        disabled={formik.values.payable_ids.length <= 1 || !isChecked}
                                                        onKeyPress={(e) => {
                                                            const allowedChars = /[0-9]/;
                                                            if (!allowedChars.test(e.key)) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                    />
                                                    <p className="text-sm font-medium text-green w-20 text-right">₹{shareAmount}</p>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                            {formik.touched.payable_ids && formik.errors.payable_ids && (
                                <div className="text-red text-sm">{formik.errors.payable_ids}</div>
                            )}
                        </div>
                        <div className="text-G300">
                            <label className="block text-sm font-normal mb-2 text-start">
                                Today Amount
                            </label>
                            <div className="relative">
                                <span className="absolute inset-y-0 left-3 flex items-center text-green font-semibold">₹</span>
                                <input
                                    type="number"
                                    name="today_amount"
                                    className="inputtext text-green"
                                    placeholder="₹ 0"
                                    style={{ paddingLeft: "25px" }}
                                    value={Math.trunc(today_amount)}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    disabled
                                />
                            </div>
                        </div>

                        {/* Submit */}
                        <div className="flex justify-end space-x-4 pt-4">
                            <button
                                type="button"
                                onClick={() => {
                                    formik.resetForm();
                                    onClose();
                                }}
                                className="w-[75px] sm:w-[93px] text-sm py-2 text-center border border-green text-green rounded-lg"
                            >
                                Close
                            </button>
                            <button
                                type="submit"
                                className={`w-[75px] sm:w-[93px] text-sm text-center py-2 rounded-lg ${isSubmitting
                                    ? "bg-green50 cursor-not-allowed"
                                    : "bg-green text-white"
                                    }`}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? "Submitting..." : "Submit"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        )
    );
};

export default EditPayableForm;





{/* Multi-select dropdown */ }
{/* <Select
    options={playerOptions}
    name="payable_ids"
    isMulti
    value={playerOptions?.filter(option =>
      formik.values?.payable_ids?.includes(option.value)
    )}
    onChange={(selectedOptions) => {
      const selectedIds = selectedOptions?.map(option => option.value);
      formik.setFieldValue("payable_ids", selectedIds);

      // Keep ratios aligned with selected players
      const newRatios = selectedOptions?.map((_, i) => formik.values.ratios[i] || "");
      formik.setFieldValue("ratios", newRatios);
    }}
  /> */}

{/* Error Message */ }
{/* {formik.touched.payable_ids && formik.errors.payable_ids && (
    <div className="text-red text-sm">{formik.errors.payable_ids}</div>
  )} */}

{/* Show booking details link */ }
{/* {formik.values.payable_ids.length > 0 && selectedTable && (
    <button
      className="text-sm text-green hover:text-blue hover:underline mt-1"
      onMouseEnter={() => setShowPlayerPopup(true)}
      onMouseLeave={() => setShowPlayerPopup(false)}
    >
      view booking details
    </button>
  )} */}

{/* Ratio and Amount Table */ }
{/* <div className="mt-3 border border-separate rounded-md p-2 space-y-2 max-h-44 overflow-y-auto vertical">
    <div className="flex justify-between items-center px-2 py-1 border-b border-gray-300 text-xs font-semibold text-gray-600 bg-gray-100">
      <div className="w-52">Player Name</div>
      <div className="w-12 text-right">Ratio</div>
      <div className="w-20 text-right">Amount</div>
    </div>

    {formik.values.payable_ids.map((id, index) => {
      const player = PlayersData?.players?.find(p => p.id === id);
      const parseRatio = (str) => {
        const num = parseInt(str, 10);
        return isNaN(num) ? 0 : num;
      };
      const totalRatio = formik.values.ratios.reduce((sum, r) => sum + parseRatio(r), 0);
      const currentRatio = formik.values.ratios[index] || "";
      const ratioAmt = totalRatio > 0 ? (formik.values.totalAmount * parseRatio(currentRatio)) / totalRatio : 0;
      const shareAmount = ratioAmt > 0 ? Math.ceil(ratioAmt / 5) * 5 : 0;

      const handleRatioChange = (e) => {
        const value = e.target.value;
        const validFormat = /^[0-9]{0,2}$/;
        if (validFormat.test(value)) {
          const updatedRatios = [...formik.values.ratios];
          updatedRatios[index] = value;
          formik.setFieldValue("ratios", updatedRatios);
        }
      };

      return (
        <div key={id} className="flex justify-between items-center border rounded-md px-2 py-[2px] bg-gray-50">
          <div className="text-sm font-medium w-52">{player?.name}</div>
          <input
            type="text"
            placeholder="2"
            className="w-12 text-sm px-2 py-[2px] border border-G80 rounded-lg outline-none text-right"
            value={currentRatio}
            onChange={handleRatioChange}
            onKeyPress={(e) => {
              const allowedChars = /[0-9]/;
              if (!allowedChars.test(e.key)) e.preventDefault();
            }}
          />
          <p className="text-sm font-medium text-green w-20 text-right">₹{shareAmount}</p>
        </div>
      );
    })}
  </div>
</div> */}

{/* Players */ }
{/* <div className="text-G300">
                            <label className="block text-sm font-normal mb-2">Payable</label>
                            <Select
                                options={playerOptions}
                                name="payable_ids"
                                isMulti
                                // value={playerOptions?.find(option =>
                                //     formik.values?.payable_ids?.[0] === option.value
                                // )}
                                // onChange={(selectedOption) => {
                                //     const id = Number(selectedOption?.value);
                                //     formik.setFieldValue("payable_ids", [id]);

                                //     const selectedPlayer = PlayersData?.players?.find(player => player.id === id);

                                //     if (selectedPlayer) {
                                //         formik.setFieldValue("previous_amount", selectedPlayer.amount);
                                //         setSelectedTable({
                                //             start_date: selectedPlayer.start_date,
                                //             start_time: selectedPlayer.start_time,
                                //         });
                                //     } else {
                                //         formik.setFieldValue("previous_amount", 0);
                                //         setSelectedTable(null);
                                //     }
                                // }}

                                value={playerOptions?.filter(option =>
                                    formik.values?.payable_ids?.includes(option.value)
                                )}
                                onChange={(selectedOptions) => {
                                    const selectedIds = selectedOptions.map(option => option.value);
                                    formik.setFieldValue("payable_ids", selectedIds);
                                }}
                            />
                            {formik.touched.payable_ids && formik.errors.payable_ids && (
                                <div className="text-red text-sm">{formik.errors.payable_ids}</div>
                            )}
                            {formik.values.payable_ids.length > 0 && selectedTable && (
                                <button
                                    className="text-sm text-green hover:text-blue hover:underline mt-1"
                                    onMouseEnter={() => setShowPlayerPopup(true)}
                                    onMouseLeave={() => setShowPlayerPopup(false)}
                                >
                                    view booking details
                                </button>
                            )}
                        </div> */}
